type IndustryCircleProps = {
  title: string
  description: string
  className?: string
  contentClassName?: string
  titleClassName?: string
  descriptionClassName?: string
  onClick?: () => void
}


const IndustryCircle = ({
  title,
  description,
  className = '',
  contentClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  onClick,
}: IndustryCircleProps) => {
  return (
    <div
      className={`
        group absolute w-10 h-10 md:w-15 md:h-15 lg:w-20 lg:h-20 xl:w-80 xl:h-80 rounded-full p-[2px] z-10
        bg-[linear-gradient(130.94deg,#745EF0_0%,rgba(116,94,240,0.1)_50%,#745EF0_100%)]
        transition-all duration-700 ease-in
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : -1}
      onKeyDown={(event) => {
        if (!onClick) return
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onClick()
        }
      }}
    >


      {/* Inner Circle */}
      <div
  className={`relative w-full h-full rounded-full flex flex-col items-center justify-center text-center p-3 text-white overflow-hidden ${contentClassName}`}
>
  {/* Base background */}
  <div className="absolute inset-0 rounded-full bg-[linear-gradient(to_top,#1e163f_20%,#19103d_30%,#0E0924_60%)]" />


  <div className="absolute inset-0 rounded-full bg-[linear-gradient(to_top,#6c50e9_20%,#27195e_50%,#160f36_70%)] opacity-0 transition-opacity duration-600 ease-in group-hover:opacity-100" />


  {/* Content */}
  <div className="relative z-10 flex flex-col items-center justify-center">
    <h2
      className={`font-semibold font-rajdhani text-base md:text-xl lg:text-2xl xl:text-3xl w-[90%] transition-all duration-300 ${titleClassName}`}
    >
      {title}
    </h2>


    <p
      className={`text-xs w-[80%] md:w-full md:text-sm lg:text-base xl:text-xl font-gilroy-medium  text-gray-400 transition-all duration-300 ${descriptionClassName}`}
    >
      {description}
    </p>
  </div>
</div>
    </div>
  )
}


export default IndustryCircle